import axios, { AxiosPromise } from 'axios';
import { IOrganization } from '../../../@types/model/masterData/organization/organization';
import { IOrganizationUpsert } from '../../../@types/model/masterData/organization/organizationUpsert';

export default class OrganizationHttpService {
    public static getOrganizationData() : AxiosPromise<Array<IOrganization>> {
        return axios.get(`${API_URL}/v1/Organization/GetAllWeb`);
    }

    public static addOrUpdateOrganization(upsert : IOrganizationUpsert) : AxiosPromise<IOrganization> {
        console.log('upsert', upsert);
        return axios.post(`${API_URL}/v1/Organization/Upsert`, upsert);
    }

    public static deleteOrganization(organizationId : number) : AxiosPromise<IOrganization> {
        return axios.delete(`${API_URL}/v1/Organization/Delete`, {
            params: { organizationId },
        });
    }
}
